import { useEffect, useState } from "react";
import socket from "./socket";
import PlayerHand from "./PlayerHand";

function GameBoard({ roomId }) {
  const [game, setGame] = useState(null);
  const [myId, setMyId] = useState(socket.id);
  const [startPlayer, setStartPlayer] = useState(null);

  useEffect(() => {
    socket.on("connect", () => setMyId(socket.id));

    socket.on("updateGame", (state) => {
      setGame(state);
    });

    return () => {
      socket.off("updateGame");
    };
  }, []);



  useEffect(() => {console.log(game)
    if(game && game.turn){
        setStartPlayer(game.turn)
    }

  }, [game])

  const playCard = (card) => {
    socket.emit("playCard", { roomId, card });
  };

  const passTurn = () => {
    socket.emit("passTurn", { roomId });
  };

  const restartGame = () => {
    socket.emit("restartGame", { roomId });
    setStartPlayer(game.turn)
  };

  if (!game) return <h2>Așteptăm jucători...</h2>;

  const me = game.players.find((p) => p.id === myId);

  return (
    <div style={{ padding: 20 }}>
            <div>
                <div>Start player {startPlayer ?? "null"}</div>
        Me: {me.id}
      {game.players.map(player => (
        <div key={player.id}>
          Socket ID: {player.id} - Cărți în mână: {player.handCount}, Colecție: {player.collectedCount}
        </div>
      ))}
    </div>
      {/* Câștigător la final */}
      {game.winner && (
        <div
          style={{
            marginTop: 20,
            padding: 10,
            border: "2px solid green",
            background: "#e0ffe0",
            borderRadius: 8,
          }}
        >
          🎉 <strong>
            {Array.isArray(game.winner.winner)
              ? "Egalitate între: " + game.winner.winner.join(", ")
              : "Câștigător: " + game.winner.winner}
          </strong>{" "}
          cu {game.winner.points} puncte!
        </div>
      )}

      <h2>Camera: {roomId}</h2>
      <p>
        Jucători conectați: {game.players.length}/{game.maxPlayers}
      </p>
      <p>Tura: {game.turn === myId ? "👉 A ta!" : game.turn}</p>
      <p>Cărți rămase în pachet: {game.deckCount}</p>

      {/* Masă */}
      <div
        style={{
          margin: "20px auto",
          padding: 20,
          border: "1px solid #444",
          width: "60%",
          borderRadius: 8,
        }}
      >
        <h3>🂠 Masă</h3>
        {game.table.length === 0 && <p>(Masa e goală)</p>}

        {game.table.map((t, i) => (
          <span key={i} style={{ margin: 5 }}>
            [{t.card.rank}
            {t.card.suit}]
          </span>
        ))}

        {/* Buton de renunțare */}
{myId === game.roundInitiator && game.canPass && (
  <button onClick={passTurn}>✋ Renunță / Pas</button>
)}
      </div>

      {/* Mâna mea */}
      {me && (
        <PlayerHand
          hand={me.hand}
          playCard={playCard}
          isMyTurn={game.turn === myId}
        />
      )}

      {/* Restart Game */}
      <div style={{ marginTop: 20 }}>
        <button
          onClick={restartGame}
          style={{
            padding: "10px 15px",
            background: "#f0ad4e",
            color: "white",
            border: "none",
            borderRadius: 5,
          }}
        >
          🔄 Restart Game
        </button>
      </div>
    </div>
  );
}

export default GameBoard;
